<i #infoTooltip [class]="iconClassesString" data-toggle="tooltip" [title]="label | translate"></i>
